import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const SelectionHeaderRow = styled('div', { label: 'SelectionHeaderRow' })`
  margin-left: -2.5px;
  margin-right: -2.5px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 5px;
  align-items: center;
`;

export const SelectionHeaderCell = styled('div', { label: 'SelectionHeaderCell' })`
  display: flex;
  align-items: center;
  justify-content: center;
`;
interface SelectionsMarginType {
    selectionsMargin: number;
}
export const SelectionMargin = styled('span', { label: 'SelectionMargin' }) <SelectionsMarginType>`
    ${({ selectionsMargin: selectionMargin }): string => selectionMargin < 100 ? `color: ${mainColors.status.error}` : ''};
   margin-right: 2px;
`;

export const ButtonChangeInPlayForAll = styled('button', { label: 'ButtonChangeInPlayForAll' })`
  cursor: pointer;
  position: relative;
  border-radius: 0;
  background: #bbb;
  border: 0;
  color: #fff;
  padding: 0.6em 1em 0.6em 1em;
  font-weight: 400;
  font-size: 0.95em;
  margin: 5px 0 5px 5px;
  line-height: 1em;
  float: right;

  &::after {
    content: '';
    position: absolute;
    display: inline-block;
    width: 0.5em;
    line-height: 2.2em;
    bottom: 0;
    left: 0;
    top: 0;
    text-align: center;
    background: #e58b52;
  }
`;

export const ChangeInPlayPopup = styled('div', { label: 'ChangeInPlayPopup' })`
    width: 400px;
    height: 180px;
    position: absolute;
    left: 50%;
    top: 170px;
    transform: translate(-50%, 0);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
